/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { BaseCard } from '@bingads-webui-campaign/overview-base-card';
import { fetchConversionTracking, getConversionGoalsFilterStore } from '@bingads-webui-campaign/overview-cards-common';
import { HelpLink } from '@bingads-webui-react/help-link';
import ConversionTrackingCardReact from './conversion-tracking-card-react/conversion-tracking-card';

const layoutSize = {
  small: 0,
  large: 1,
};
const layoutBreakPoint = 800;

function getLayoutSize() {
  if (this.$el.closest('.card-holder__wrapper').outerWidth() < layoutBreakPoint) {
    return layoutSize.small;
  }
  return layoutSize.large;
}

const conversionTileFetch = ({
  entitySet,
  filter,
  jsdata,
  getCardsConfig,
  dateUtil,
  permissions,
  disableCache,
  cacheManager,
  accountsMode,
  typeId,
}) => {
  const fetch = ({
    dateRange,
    metric,
    selectedMenuItem,
    fetchSingleTile = false,
  }) => fetchConversionTracking({
    dateRange,
    selectedMenuItem,
    metric,

    entitySet,
    filter,
    jsdata,
    getCardsConfig,
    dateUtil,
    fetchSingleTile,
    permissions,
    disableCache,
    cacheManager,
    accountsMode,
    dfmCacheKey: typeId,
  });

  return fetch;
};

export class ConversionTrackingCard extends BaseCard {
  get className() {
    return 'conversion-tracking-card';
  }

  get menuItems() {
    if (this.viewRef.current) {
      const items = this.viewRef.current.getMenuItems();
      if (_.isEmpty(items)) {
        return null;
      }
      return items;
    }
    return null;
  }

  onMenuAction(menuItem) {
    if (this.viewRef.current) {
      const { selectedMenuItem } = this.viewRef.current.state;
      if (selectedMenuItem === menuItem) {
        return;
      }
      this.viewRef.current.handleUpdate({
        selectedMenuItem: menuItem,
      });
    }
  }

  getCardPreference() {
    if (this.viewRef.current) {
      const { selectedMenuItem, metric } = this.getState();

      return {
        metric,
        selectedMenuItem,
      };
    }
    return {};
  }

  initialize(props) {
    const {
      // entitySet,
      // metric,
      // selectedMenuItem,
      // dateRange,
      // filter,
      perfMarker,
      name,
      sharedOptions,
      deps,
      // accountsMode,
      // scope,
      // dismissLastFluctuation = false,
      // typeId,
      // newI18n,
      preferenceService,
    } = props;

    const {
      i18n,
      jsdata,
      dateUtil,
      cacheManager,
      config,
    } = deps;

    const permissions = config && config.get('Permissions');
    const { getCardsConfig } = sharedOptions;
    this.initPerfMarker({ perfMarker, name });
    this.viewRef = React.createRef();
    const conversionGoalsFilterStore = getConversionGoalsFilterStore({ preferenceService });

    this.view = (
      <React.Fragment>
        <HelpLink className="hiddenHelpBridge" style={{ display: 'none' }} tabIndex={-1} query="help:app54555" ariaLabel="Click to learn more about conversion tracking tile" />
        <ConversionTrackingCardReact
          ref={this.viewRef}
          i18n={i18n}
          deps={deps}
          getCardsConfig={getCardsConfig}
          permissions={permissions}
          fetch={conversionTileFetch({
            ...props,
            jsdata,
            dateUtil,
            cacheManager,
            permissions,
            getCardsConfig,
          })}
          {...props}
          triggerChangeMenuItem={(menuItems) => {
            this.trigger('change:menuItems', {
              value: menuItems,
              options: { replace: true },
            });
          }}
          triggerChangeMetric={(newMetric) => {
            this.trigger('pick', {
              metric: newMetric,
            });
          }}
          triggerPreferenceChange={() => {
            this.trigger('storeCardPreference', this.getCardPreference());
          }}
          blockCard={() => {
            this.blockCard();
          }}
          willFetchData={() => {
            this.willFetchData();
          }}
          renderedWithData={() => {
            this.renderedWithData();
          }}
          unblockCard={() => {
            this.unblockCard();
          }}
          TrackingTypeFilterStore={(errorType) => {
            if (errorType) {
              const newErrorTypeFilter = {
                TrackingStatus: {
                  $in: [`Enum.GoalTrackingStatus'${errorType}'`],
                },
              };

              conversionGoalsFilterStore.save({ query: newErrorTypeFilter });
            }
          }}
          GoalCategoryFilterStore={(category) => {
            if (category) {
              const newCategoryFilter = {
                GoalCategory: {
                  $in: [`Enum.GoalCategory'${category}'`],
                },
              };

              conversionGoalsFilterStore.save({ query: newCategoryFilter });
            }
          }}
        />
      </React.Fragment>
    );

    this.onResize(() => {
      this.relayout();
    });
  }

  relayout() {
    const newLayoutSize = getLayoutSize.call(this);

    if (this.currentLayoutSize === newLayoutSize) {
      return;
    }

    if (newLayoutSize === layoutSize.small) {
      this.$el.addClass('small_layout');
    } else {
      this.$el.removeClass('small_layout');
    }

    this.currentLayoutSize = newLayoutSize;
  }

  setState(state) {
    if (this.viewRef.current) {
      this.viewRef.current.handleUpdate(state);
    }
    return this;
  }

  renderTrunk() {
    ReactDOM.render(this.view, this.el);
    _.defer(() => {
      this.relayout();
    });
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
